export const BasicTable = ({ columns, data }) => {
  if (!data || data.length === 0)
    return (
      <h1 className="font-heading text-2xl text-center my-8 text-flyers-mid-gray uppercase">
        No Data
      </h1>
    );

  const getNestedValue = (obj, path) => {
    try {
      return path.split(".").reduce((acc, part) => acc && acc[part], obj);
    } catch (error) {
      console.log(path);
    }
  };

  const headers = () =>
    columns.map((column) => (
      <th
        key={column.key}
        className="bg-flyers-charcoal text-flyers-orange font-heading font-bold uppercase tracking-wider text-sm py-3 px-4 sticky top-0 z-10 border-b-2 border-flyers-orange"
      >
        {column.label}
      </th>
    ));

  const tableData = () =>
    data.map((row, rowIndex) => (
      <tr
        key={rowIndex}
        className="border-b border-flyers-dark-gray hover:bg-flyers-charcoal transition-colors duration-100"
      >
        {columns.map((column, valueIndex) => {
          const cellData = getNestedValue(row, column.key);
          const formattedValue = column.format ? column.format(cellData) : cellData;
          return (
            <td
              key={valueIndex}
              className={`py-3 px-4 text-center text-flyers-light-gray text-sm ${
                column.clickHandler
                  ? "cursor-pointer hover:text-flyers-orange transition-colors duration-100"
                  : ""
              }`}
              onClick={
                column.clickHandler
                  ? () => column.clickHandler(getNestedValue(row, column.itemID))
                  : null
              }
            >
              {formattedValue}
            </td>
          );
        })}
      </tr>
    ));

  return (
    <div className="overflow-x-auto max-h-[70vh] rounded-lg border border-flyers-dark-gray">
      <table className="min-w-full leading-normal bg-flyers-black">
        <thead>
          <tr>{headers()}</tr>
        </thead>
        <tbody>{tableData()}</tbody>
      </table>
    </div>
  );
};
